var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.025 6.2002C25.0527 6.2002 26.0383 6.60845 26.765 7.33516C27.4917 8.06186 27.9 9.04748 27.9 10.0752V22.4752C27.9 23.5029 27.4917 24.4885 26.765 25.2152C26.0383 25.9419 25.0527 26.3502 24.025 26.3502H6.97501C5.94729 26.3502 4.96167 25.9419 4.23497 25.2152C3.50826 24.4885 3.10001 23.5029 3.10001 22.4752V10.0752C3.10001 9.04748 3.50826 8.06186 4.23497 7.33516C4.96167 6.60845 5.94729 6.2002 6.97501 6.2002H24.025ZM26.35 12.3397L15.8937 18.4932C15.7949 18.5513 15.6844 18.5867 15.5702 18.5969C15.456 18.607 15.341 18.5918 15.2334 18.5521L15.1063 18.4932L4.65001 12.3428V22.4752C4.65001 23.0918 4.89496 23.6832 5.33098 24.1192C5.76701 24.5552 6.35838 24.8002 6.97501 24.8002H24.025C24.6416 24.8002 25.233 24.5552 25.669 24.1192C26.1051 23.6832 26.35 23.0918 26.35 22.4752V12.3397ZM24.025 7.7502H6.97501C6.35838 7.7502 5.76701 7.99515 5.33098 8.43117C4.89496 8.86719 4.65001 9.45857 4.65001 10.0752V10.5433L15.5 16.9262L26.35 10.5402V10.0752C26.35 9.45857 26.1051 8.86719 25.669 8.43117C25.233 7.99515 24.6416 7.7502 24.025 7.7502Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailTransparent);
export default __webpack_public_path__ + "static/media/mailTransparent.e59203bae7dfd5e243ea57897e8fee50.svg";
export { ForwardRef as ReactComponent };